import { API } from "@/lib/api";

// Reads a POST Server-Sent-Events stream (data: {json}\n\n) and yields parsed events as they arrive.
export async function* streamSSE(path, body, signal) {
  const res = await fetch(`${API}${path}`, {
    method: "POST", credentials: "include", signal,
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
  });
  if (!res.ok) {
    let data = {};
    try { data = await res.json(); } catch { /* non-JSON error body */ }
    const err = new Error(data?.error?.message || (typeof data?.detail === "string" ? data.detail : `HTTP ${res.status}`));
    err.code = data?.error?.code;
    err.attempts = data?.error?.attempts;
    throw err;
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf("\n\n")) >= 0) {
      const line = buf.slice(0, i).split("\n").find((l) => l.startsWith("data:"));
      buf = buf.slice(i + 2);
      if (line) yield JSON.parse(line.slice(5).trim());
    }
  }
}
